import type { LinkTileProps } from '@src/components/LinkTile/LinkTile.props'
import { getStatisticsCopy } from '@src/mappers/media/media-display.helpers'

export const cocoaProgramToRailItem = (item: CocoApi.CollectionItem): Partial<LinkTileProps> => {
  return {
    title: item.title,
    violator: item.stamps?.[0]?.title,
    imageUrl: item.backgroundImage ?? '',
    href: item.redirectUrl,
    description: getStatisticsCopy(item.statistics) || item.descriptionShort,
  }
}
